import React from 'react';
import Dashboard from '../pages/Dashboard';
import ManagerDashboard from '../pages/ManagerDashboard';
import { getUserRole } from '../utils/auth';

const ConditionalDashboard = () => {
  const userRole = getUserRole();
  
  // If user is admin, show regular Dashboard
  if (userRole?.role === 'admin') {
    return <Dashboard />;
  }
  
  // For manager and staff, show ManagerDashboard
  return <ManagerDashboard />;
};

export default ConditionalDashboard;
